import { useState } from "react";
import {Container, Form, Button, Row, Col, Card, Toast, ToastContainer} from "react-bootstrap";
import axios from "axios"; // or use fetch if you prefer

const ContactForm = () => {
    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        message: "",
      });
      const [showToast, setShowToast] = useState(false);
      const [toastMessage, setToastMessage] = useState("");
      const [toastVariant, setToastVariant] = useState("success");
    
      const handleChange = (e) => {
        setFormData({
          ...formData,
          [e.target.name]: e.target.value,
        });
      };
    
      const handleSubmit = async (e) => {
        e.preventDefault();
      
        const form = new FormData();
        form.append("name", formData.name);
        form.append("phone", formData.phone);
        form.append("email", formData.email);
        form.append("message", formData.message);
      
        try {
          const response = await axios.post("https://rptravelskri.com/submit_form.php", form);
      
          if (response.data.status === "success") {
            setToastVariant("success");
            setToastMessage("Message sent successfully!");
            setShowToast(true);
            setFormData({ name: "", phone: "", email: "", message: "" });
          } else if (response.data.status === "exists") {
            setToastVariant("warning");
            setToastMessage("Already registered with this Email or Phone.");
            setShowToast(true);
          } else {
            setToastVariant("danger");
            setToastMessage("Something went wrong: " + response.data.error);
            setShowToast(true);
          }
        } catch (error) {
          setToastVariant("danger");
          setToastMessage("Error sending form. Please try again.");
          setShowToast(true);
        }
      
  };

  return (
    <section id="contact" className="content-section" >
      <Container data-aos="fade-up" data-aos-delay="600">
        <h2 className="section-title">Contact Us</h2>
    
        {/* Big Card including Info + Form */}
        <Card className="contact-card p-4">
          <Row>
            {/* Left - Contact Info */}
            <Col md={6} className="text-start">
              <h5>Contact Information</h5>
              <p><i className="bi bi-envelope-fill me-2"></i> info@rptravelskri.com</p>
              <p><i className="bi bi-telephone-fill me-2"></i>+91 8016480440</p>
              <p><i className="bi bi-whatsapp me-2"></i>+91 9239030519</p>
              <p><i className="bi bi-globe2 me-2"></i>www.rptravelskri.com</p>
              
              <h5 className="mt-4">Office Address</h5>
              <p>RN Tagore Road, Post Office More, Krishnagar, Nadia, </p>
              <p>PIN - 741101</p>
            </Col>
    <Col md={6}>
      <h5>Send us a Message</h5>
      <Form className="mt-3" onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Control
            type="text"
            placeholder="Your Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </Form.Group>
        <Form.Group className="mb-3">
        <Form.Group className="mb-3">
        <Form.Control
            type="text"
            placeholder="Phone Number"
            name="phone"
            value={formData.phone}
            onChange={(e) => {
            const cleaned = e.target.value.replace(/\D/g, '');
            if (cleaned.length <= 10) {
                setFormData({ ...formData, phone: cleaned });
            }
            }}
            required
        />
        </Form.Group>

        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Control
            type="email"
            placeholder="Email Address"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Control
            as="textarea"
            rows={4}
            placeholder="Your Message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
          />
        </Form.Group>
        <div className="text-center">
          <Button variant="danger" type="submit" className="px-5">
            Submit
          </Button>
        </div>
      </Form>

       {/* Bootstrap Toast */}
       <ToastContainer position="top-center" className="p-3">
        <Toast
          bg={toastVariant}
          show={showToast}
          delay={3000}
          autohide
          onClose={() => setShowToast(false)}
        >
          <Toast.Body className="text-white">{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </Col>
     </Row>
        </Card>
    
      </Container>
    </section>
  );
};

export default ContactForm;
